var loop = function loop(times, callback) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  for (var index = 0; index < times; index++) {
    callback.apply(void 0, [index + 1, index].concat(args));
  }
};

var doTimes = function doTimes(times, callback) {
  var constructor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (typeof times !== 'number') {
    throw 'do-times expected the first argument to be a number';
  }

  if (typeof callback !== 'function') {
    throw 'do-times expected the second argument to be a function';
  }

  if (!!constructor && typeof constructor !== 'boolean') {
    throw 'do-times expected the third argument to be a boolean';
  }

  if (!constructor) {
    loop(times, callback);
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return loop.apply(void 0, [times, callback].concat(args));
  };
};

module.exports = doTimes;